function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  d: "M20.15 20.13c-.82-.89-3.2-1.49-4.05-1.98-1.65-.7-1.27-1.85-1.27-1.92 0-.25.13-1.41.13-1.41s1.09-.97 1.6-2.44c.82-.51 1.13-.65 1.26-1.22 0 0 .25-2.32-.63-2.32 0 0-.38.06-.26-.45.13-.58.07-2.25 0-2.82-.06-.58.17-1.52-1.14-2.5-.65-.38-1.15-.72-2.24-.88-.3-.05-.7-.12.27-1.05-1.18-.6-2.3.93-2.67.94-.85.04-1.35.2-2.18.59a3.28 3.28 0 0 0-1.7 2.44c-.07.56-.13 2.24-.07 3.13.06.51-.32.51-.32.51-.7 0-.38 2.32-.38 2.32.13.57 0 .83 1.09 1.28.5 1.47 1.84 2.25 1.84 2.25s.06.96.06 1.67c-.12-.07.38 1.72-3.04 2.24-3.42.51-4.06 1.6-4.69 2.25-.43.43-.69 1.58-.76 2.23 5.02 0 21 .02 21 0s-.77-1.7-1.85-2.86z"
});

var SvgYouth = function SvgYouth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgYouth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youth.f8ce4426.svg";
export { ForwardRef as ReactComponent };